import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { isRenderingForMobileApp } from 'src/constants';
import { FooterMenuItem } from '~components/footer-menu-item/footer-menu-item.component';
import { AuthService } from '~services';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  public year: number = new Date().getFullYear();
  public isMobileRender: boolean = isRenderingForMobileApp;

  public menuItems: FooterMenuItem[] = [
    {
      label: 'For Customers',
      items: [
        {
          label: 'Account',
          items: [
            {
              label: 'Sign up',
              link: '/au/create-an-account',
            },
            {
              label: 'Log in',
              action: () => this.signIn(),
            },
            {
              label: 'Zip Pay',
              link: '/au/zip-pay',
            },
            {
              label: 'Zip Money',
              link: '/au/zip-money',
            },
          ],
        },
        {
          label: 'Shop',
          items: [
            {
              label: 'Shop with Zip',
              link: '/au/shop',
            },
            {
              label: 'Gift cards',
              link: '/au/giftcards/',
            },
            {
              label: 'Cashback offers',
              link: '/au/shop/cashback',
            },
            {
              label: 'See all stores',
              link: '/au/store/directory',
            },
          ],
        },
        {
          label: 'Features',
          items: [
            {
              label: 'How Zip works',
              link: '/au/how-zip-works',
            },
            {
              label: 'Zip Rewards',
              link: '/au/rewards',
            },
            {
              label: 'Tap to pay with Zip',
              link: '/au/tap-zip',
            },
            {
              label: 'Single-use card',
              link: '/au/single-use-card',
            },
            {
              label: 'Zip Money instalments',
              link: '/au/zip-money-instalments',
            },
            {
              label: 'Product Protection',
              link: '/au/product-protection',
            },
            {
              label: 'Pay bills with Zip',
              link: '/au/bills',
            },
          ],
        },
      ],
    },
    {
      label: 'For Businesses',
      items: [
        {
          label: 'Merchant sign up',
          link: '/au/business/payments/apply',
        },
        {
          label: 'Merchant log in',
          link: 'https://merchant.zip.co',
        },
        {
          label: 'Offer Zip in your store',
          link: '/au/business/payments',
        },
        {
          label: 'Integration guides',
          link: 'https://developers.zip.co/docs',
        },
        {
          label: 'Zip API',
          link: 'https://developers.zip.co/v2/docs',
        },
      ],
    },
    {
      label: 'Support',
      items: [
        {
          label: 'Help & FAQs',
          link: 'https://help.zip.co/hc/en-us',
        },
        {
          label: 'Buyers protection',
          link: '/au/page/buyers-protection',
        },
        {
          label: 'Disputes & complaints',
          link: '/au/page/disputes-and-complaints',
        },
        {
          label: 'Financial wellbeing',
          link: '/au/page/financial-wellbeing',
        },
        {
          label: 'Financial hardship',
          link: '/au/page/vulnerability-and-hardship',
        },
        {
          label: 'Family violence',
          link: '/au/page/fdv-assistance',
        },
        {
          label: 'Vulnerability Disclosure Program',
          link: '/vulnerability-disclosure-program',
        },
      ],
    },
    {
      label: 'Company',
      items: [
        {
          label: 'About Zip',
          link: '/about-us',
        },
        {
          label: 'Careers',
          link: '/careers',
        },
        {
          label: 'Investors',
          link: '/investors',
        },
        {
          label: 'BNPL Code of Practice',
          link: '/au/page/buy-now-pay-later-code-of-practice',
        },
      ],
    },
  ];
  public appItems: Array<{ link: string; iconSrc: string; alt: string }> = [
    {
      link: 'https://apps.apple.com/au/app/zip-shop-now-pay-later/id1411824359',
      iconSrc: '/au/giftcards/assets/app-store.svg',
      alt: 'Download the Zip App on the App Store',
    },
    {
      link: 'https://play.google.com/store/apps/details?id=co.zip',
      iconSrc: '/au/giftcards/assets/google-play.svg',
      alt: 'Download the Zip App on the Google Play Store',
    },
  ];
  public legalItems: Array<{ label: string; link: string }> = [
    {
      label: 'Terms of Use',
      link: '/au/page/terms-and-conditions',
    },
    {
      label: 'Privacy',
      link: '/au/page/privacy',
    },
    {
      label: 'Security',
      link: '/au/security',
    },
    {
      label: 'Important Information',
      link: '/au/page/important-information',
    },
    {
      label: 'Target Market Determination',
      link: '/au/page/target-market-determination',
    },
  ];
  public socialItems: Array<{ link: string; iconSrc: string; alt: string }> = [
    {
      link: 'https://www.instagram.com/zip_au',
      iconSrc: '/au/giftcards/assets/instagram-icon.svg',
      alt: 'Find us on Instagram',
    },
    {
      link: 'https://www.facebook.com/zipAU',
      iconSrc: '/au/giftcards/assets/facebook-icon.svg',
      alt: 'Find us on Facebook',
    },
    {
      link: 'https://www.linkedin.com/company/zip-co-limited',
      iconSrc: '/au/giftcards/assets/linkedin-icon.svg',
      alt: 'Find us on LinkedIn',
    },
  ];

  constructor(private authService: AuthService, private location: Location) {}

  signIn() {
    this.authService.navigateToLoginPage(this.location.path());
  }
}
